import React from 'react';
import { Switch, Route } from 'react-router-dom';

import PermissionRoute from 'components/PermissionRoute';
import NotFound from 'scenes/NotFound';
import { VERTICAL_URL } from 'settings';
import { BankDetails } from 'v2/components/Pages/BankDetails';
import GlobalLoading from 'v2/components/Shared/GlobalLoading';
import withPartnerOnly from 'v2/components/Shared/withPartnerOnly';

const AddBankAccount = React.lazy(() => import('../../../v2/components/Pages/AddBankAccount'));

const PartnerOnlyPermissionRoute = withPartnerOnly(PermissionRoute);

const Profile = () => {
  const base = '/producer/profile';

  return (
    <Switch>
      <PartnerOnlyPermissionRoute
        action='no-access-control-permission'
        path={`${base}/bankdata`}
        component={BankDetails}
      />
      <PermissionRoute
        action='no-access-control-permission'
        path={`${base}/payment`}
        render={() => {
          window.location.href = `${VERTICAL_URL}/subscriptions/cards/me`;
          return <GlobalLoading />;
        }}
      />
      <PermissionRoute
        action='no-access-control-permission'
        path={`${base}/add-bank-account`}
        component={AddBankAccount}
      />
      <Route path='*' component={NotFound} />
    </Switch>
  );
};
export default Profile;
